<template>
    <div class="container-table taxDocumentsInMovement">
        <b-table
            :data="data.tax_documents"
            backend-pagination
            backend-sorting
            :show-header="false"
        >
            <b-table-column>
                <p></p>
            </b-table-column>
            <b-table-column field="document_number" centered v-slot="props">
                <p
                    v-if="!props.row.obligation_type.has_auto_doc_number"
                    class="document-number has-text-weight-bold is-size-6 is-family-monospace"
                >
                    {{ props.row.document_number }}
                </p>
                <span
                    v-if="!props.row.obligation_type.has_auto_doc_number"
                    class="is-size-7"
                    >Nro Documento
                </span>
            </b-table-column>
            <b-table-column
                field="obligation_type.name"
                numeric
                centered
                cellClass="obligation-type"
                v-slot="props"
            >
                <div class="is-flex is-justify-content-center">
                    <img
                        alt="obligacion proveniente desde el SII"
                        style="max-width:20px"
                        :src="siiLogo"
                        v-if="props.row.obligation_type.sii_code !== null"
                    />
                    <span class="ml-1">{{
                        props.row.obligation_type.name
                    }}</span>
                </div>
            </b-table-column>
            <b-table-column
                field="counterpart.name"
                cellClass="document-name has-text-weight-bold"
                v-slot="props"
            >
                <div class="counterpart-name">
                    <span>
                        {{ props.row.counterpart.name }}
                    </span>
                    <span v-if="isRendition(props.row)"
                        >- {{ props.row.description }}</span
                    >
                </div>
                <div class="counterpart-rut">
                    {{ props.row.counterpart.rut }}
                </div>
            </b-table-column>

            <b-table-column
                field="amount"
                numeric
                cellClass="document-amount"
                v-slot="props"
            >
                <span
                    class="is-size-6 has-text-weight-semibold is-family-monospace"
                >
                    {{ getAmount(props.row) | toMoney }}
                </span>
                <br />
                <span class="is-size-7">MONTO OBLIGACIÓN </span>
                <br />
            </b-table-column>
        </b-table>
    </div>
</template>

<script>
import siiMini from "@/assets/images/sii-mini.svg";
import { parseToMoney } from "@/utils/currency";

export default {
    name: "ListBankMovementsDetail",
    props: ["data"],
    filters: {
        toMoney: (value) => {
            return parseToMoney(value);
        },
    },
    data() {
        return {
            siiLogo: siiMini,
        };
    },
    methods: {
        isRendition(item) {
            return item.obligation_type.name === "Rendición";
        },
        getAmount(itemTaxDocument) {
            if (
                itemTaxDocument.obligation_type.name == "Boleta de Honorarios"
            ) {
                return (
                    itemTaxDocument.reconciliation_amount +
                    itemTaxDocument.pending_reconciliation_amount
                );
            }
            return itemTaxDocument.amount;
        },
    },
};
</script>
